import { useState } from "react";
import { Reveal } from "./Reveal";

const GarmentCaption = ({ item }) => (
    <figcaption className="mt-4 flex items-baseline justify-between gap-4">
        <div className="flex items-baseline gap-3 md:gap-4 min-w-0">
            <span className="font-mono2 text-[10px] md:text-xs text-[var(--red)]">{item.id}</span>
            <span className="font-display text-sm md:text-lg uppercase tracking-tight truncate" data-testid={`merch-name-${item.id}`}>
                {item.name}
            </span>
        </div>
        <span className="font-mono2 text-[9px] md:text-[10px] tracking-[0.15em] text-[var(--mute)] uppercase whitespace-nowrap">
            {item.variant}
        </span>
    </figcaption>
);

export const GarmentCard = ({ item, className = "", delay = 0 }) => {
    const [flat, setFlat] = useState(false);

    return (
        <Reveal className={className} delay={delay}>
            <figure
                className={`garment-card group relative cursor-pointer select-none ${flat ? "is-flat" : ""}`}
                onClick={() => setFlat((v) => !v)}
                data-testid={`merch-card-${item.id}`}
                data-cursor="VIEW"
                data-state={flat ? "flat" : "photo"}
            >
                <div className="relative aspect-[3/4] overflow-hidden bg-[#101010]">
                    <img
                        src={item.photo}
                        alt={item.alt}
                        loading="lazy"
                        decoding="async"
                        className="garment-photo absolute inset-0 w-full h-full object-cover"
                        data-testid={`merch-photo-${item.id}`}
                    />
                    <img
                        src={item.flat}
                        alt={`Technical flat artwork of ${item.name}`}
                        loading="lazy"
                        decoding="async"
                        className="garment-flat absolute inset-0 w-full h-full object-cover"
                        data-testid={`merch-flat-${item.id}`}
                    />
                    <span
                        className="tap-hint absolute bottom-3 left-3 font-mono2 text-[9px] tracking-[0.2em] uppercase px-2 py-1 bg-[rgba(10,10,10,0.65)] backdrop-blur-sm border border-[var(--line)] text-[var(--bone)]"
                        data-testid={`merch-toggle-hint-${item.id}`}
                    >
                        {flat ? "FLAT ARTWORK" : "PHOTO"} — TAP
                    </span>
                </div>
                <GarmentCaption item={item} />
            </figure>
        </Reveal>
    );
};
